import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { upload } from 'react-icons-kit/fa/upload'
import { ptBR } from '@material-ui/core/locale';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Icon } from 'react-icons-kit'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit'
import { ic_picture_as_pdf } from 'react-icons-kit/md/ic_picture_as_pdf'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Swal from 'sweetalert2'
import Checkbox from '@material-ui/core/Checkbox';
import withReactContent from 'sweetalert2-react-content'
import { ic_watch_later } from 'react-icons-kit/md/ic_watch_later'
import { ic_gavel } from 'react-icons-kit/md/ic_gavel'
import { ic_thumbs_up_down } from 'react-icons-kit/md/ic_thumbs_up_down'
import { ic_work } from 'react-icons-kit/md/ic_work'
import { ic_assignment_turned_in } from 'react-icons-kit/md/ic_assignment_turned_in'
import { edit } from 'react-icons-kit/fa/edit'
import $ from 'jquery'
import api from '../../services/api'
import FrOfertaDetail from '../FrOfertaDetail';
import FrLoading from '../FrLoading'
import download from 'downloadjs'

import './index.css';

const icons = [
  { fk_sne: 1, icon: (<Icon size={32} style={{ color: '#2A9D8F' }} icon={ic_thumbs_up_down} />) },
  { fk_sne: 2, icon: (<Icon size={32} style={{ color: '#E9C46A' }} icon={ic_work} />) },
  { fk_sne: 3, icon: (<Icon size={32} style={{ color: '#EF233C' }} icon={ic_gavel} />) },
]

const swal = withReactContent(Swal)

const theme = createMuiTheme({
  palette: {
    primary: { main: '#1976d2' },
  },
}, ptBR);

const FrCheckBox = withStyles({
  root: {
    color: 'black',
    '&$checked': {
      color: 'black',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);



const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: '#fab26e'
    },
    "& .Mui-selected:hover": {
      backgroundColor: '#fab26e'
    },
    width: '100%',
  },
  container: {
    maxHeight: '58vh',
    minHeight: '58vh'
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F1873B',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);



function FrTable(props) {
  const classes = useStyles();
  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState(props.data)
  const [columns, setColumns] = useState(props.columns)
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState(props.columns[0].id);
  const [selected, setSelected] = React.useState([]);
  const [opened, setOpened] = React.useState([]);

  useEffect(() => {
    setData(props.data)
    setPage(0)
  }, [props.data])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (props.onChangeCheckbox) props.onChangeCheckbox(selected)
  }, [selected])

  function handleDelete(e, id, table) {
    e.preventDefault()
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja excluir PERMANENTEMENTE o registro selecionado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        api.post('/' + table + '/delete/' + id).then(r => {
          if (r.status === 200) {
            swal.fire({
              title: 'Registro Excluído',
              text: "O registro foi excluído com sucesso!",
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                window.location.reload()
              }
            })
          } else {
            swal.fire({
              title: 'Erro!',
              text: "O registro não foi excluído!",
              icon: 'warning',
            })
          }
        })
      }
    })
  }

  function handlePdf(e, id, table) {
    e.preventDefault()
    console.log(id)
    var foundData = false
    swal.fire({
      html: <FrLoading text="Em Processamento..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/termo_adesao?id=' + id,  {responseType: 'blob'}).then(r => {
      let name = 'download.pdf'  
      let type = 'applicaton/pdf'
      if (r.data.size>0){
        foundData=true
      }
      var blob = new Blob([r.data], {
        type: type
        });
        download(blob, name)
        swal.close()
    })
    setTimeout(() => {
      if(!foundData){
        swal.fire({
          title: 'Atenção!',
          text: "Arquivo não foi encontrado!",
          icon: 'warning',
        })
      } else {
        swal.close()
      }
    }, 8000)
    // const url = api.backendUrl + '/api/termo_adesao?id=' + id;
    // var link = document.createElement("a");
    // link.setAttribute('download', 'proposta.pdf');
    // link.href = url;
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
  }

  function handleCheckSign(e, id, idAutentique, email, name) {
    e.preventDefault()
    console.log(id, idAutentique, email, name)
    if (idAutentique) {
      api.get('/termo_adesao/check_signed?id=' + id + '&idAutentique=' + idAutentique).then(r => {
        if (r.data.signed) {
          swal.fire({
            text: "O documento já foi assinado!",
            icon: 'success',
          })
        } else {
          swal.fire({
            text: "O documento ainda não foi assinado!",
            icon: 'error',
          })
        }
      })
    } else {
      let emailAutentique = email
      swal.fire({
        title: 'Proposta não enviada para Autentique',
        text: "Deseja enviar a proposta selecionada para Autentique?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        input: 'text',
        inputLabel: 'Email do Proponente',
        inputValue: emailAutentique,
        inputValidator: (value) => {
          if (!value) {
            return 'Você precisa informar um email!'
          }
        }
      }).then((result) => {
        if (result.value) {
          emailAutentique = result.value
          api.get('/autentique/sign?id=' + id + '&email=' + emailAutentique + '&name' + name).then(r => {
            if (r.status === 200) {
              swal.fire({
                title: 'Proposta Enviada',
                text: "A proposta foi enviada para a Autentique com sucesso!",
                icon: 'success',
              }).then((result) => {
                if (result.value) {
                  window.location.reload()
                }
              })
            } else {
              swal.fire({
                title: 'Erro!',
                text: "A proposta não foi enviada!",
                icon: 'warning',
              })
            }
          })
        }
      })
    }
  }

  function handleManualSign(e, id) {
    e.preventDefault()
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja setar a proposta como assinada manualmente?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        api.post('/propostas/assinar/' + id).then(r => {
          if (r.status === 200) {
            swal.fire({
              title: 'Proposta assinada!',
              text: "Proposta assinada com sucesso!",
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                window.location.reload()
              }
            })
          }
        })
      }
    })

  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n[props.codeName]);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    console.log(name)
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleClickDetail = (event, name) => {
    console.log(name)
    const selectedIndex = opened.indexOf(name);
    let newOpened = [];

    if (selectedIndex === -1) {
      newOpened = newOpened.concat(opened, name);
    } else if (selectedIndex === 0) {
      newOpened = newOpened.concat(opened.slice(1));
    } else if (selectedIndex === opened.length - 1) {
      newOpened = newOpened.concat(opened.slice(0, -1));
    } else if (selectedIndex > 0) {
      newOpened = newOpened.concat(
        opened.slice(0, selectedIndex),
        opened.slice(selectedIndex + 1),
      );
    }

    setOpened(newOpened);
  }

  const selectFile = (e, codigo) => {
    e.preventDefault();
    $('#html_btn_manual_' + codigo).click();
  }

  const handleUpload = (e, codigo, registro) => {
    window.location.href = '/sistema/propostaAssociado/registro?codigo='+codigo
  } 

  const handleSelectedFile = (e, codigo) => {
    let file = e.target.files[0];
    console.log(file)
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja fazer o upload manual do termo assinado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        let formData = new FormData();
        formData.append('file', file, file.name)
        api.post('/termos/manual/' + codigo, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(r => {
          if (r.status === 200) {
            swal.fire({
              title: 'Termo registrado!',
              text: "O termo de adesão foi registrado com sucesso!",
              icon: 'success',
            })
          } else {
            swal.fire({
              title: 'Erro!',
              text: "Ocorreu um erro no upload do termo!",
              icon: 'error',
            })
          }
        })
      }
    })
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const isOpened = (name) => opened.indexOf(name) !== -1;

  return (
    <ThemeProvider theme={theme}>
      {(data.length === 0) ? (
        <div>{props.searched ? 'Registro(s) não encontrado(s)!' : ''}</div>
      ) : (
        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell padding="checkbox">
                    {/* <FrCheckBox
                      indeterminate={selected.length > 0 && selected.length < data.length}
                      checked={data.length > 0 && selected.length === data.length}
                      onChange={handleSelectAllClick}
                      inputProps={{ 'aria-label': 'select all desserts' }}
                    /> */}
                  </StyledTableCell>
                  {props.detail ? <StyledTableCell style={{ minWidth: 30, width: 30 }} /> : (<></>)}
                  {!props.readOnly ? (
                    <StyledTableCell
                      style={{ minWidth: 150, width: 160 }}
                    >
                      Opções
                    </StyledTableCell>) : (<></>)}
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={createSortHandler(column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {stableSort(data, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                  const isItemSelected = isSelected(row[props.codeName]);
                  const isItemOpened = isOpened(row[props.codeName]);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  if (props.detail) {
                    return (
                      <>
                        <TableRow aria-checked={isItemSelected} hover role="checkbox" tabIndex={-1} key={row[props.codeName]} selected={isItemSelected}>
                          <TableCell padding="checkbox" onClick={(event) => handleClick(event, row[props.codeName])} >
                            <FrCheckBox
                              checked={isItemSelected}
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton aria-label="expand row" size="small" onClick={(event) => handleClickDetail(event, row[props.codeName])}>
                              {isItemOpened ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                          </TableCell>
                          {!props.readOnly ? (
                            <TableCell>

                              {props.propostas ? (
                                <>
                                  <input
                                    type="file"
                                    name="arquivo"
                                    id={"html_btn_manual_" + row[props.codeName]}
                                    accept=".png, .jpg, .jpeg"
                                    onChange={e => handleSelectedFile(e, row[props.codeName])}
                                    hidden
                                  />
                                  <Tooltip title="Fazer upload do Termo de Adesão">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <button type="file" onClick={e => selectFile(e, row[props.codeName])}>
                                        <Icon icon={upload} size={20} />
                                      </button>
                                    </div>
                                  </Tooltip>
                                  <Tooltip title="Imprimir Termo de Adesão">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <Icon className="tableDelete" key="pdf" icon={ic_picture_as_pdf} size={18} onClick={(e) => handlePdf(e, row[props.codeName], props.regName)} />
                                    </div>
                                  </Tooltip>
                                  <Tooltip title="Checar Assinatura">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <Icon className="tableDelete" key="checkSign" icon={ic_assignment_turned_in} size={18} onClick={(e) => handleCheckSign(e, row[props.codeName], row['ID_AUTENTIQUE'], row['EMAIL'], row['RAZAO_SOCIAL'])} />
                                    </div>
                                  </Tooltip>
                                  <Tooltip title="Marcar como Assinado">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <Icon className="tableDelete" key="manualSign" icon={edit} size={18} onClick={(e) => handleManualSign(e, row[props.codeName])} />
                                    </div>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <Tooltip title="Editar registro">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <Link to={"/sistema/" + props.regName + "/registro?codigo=" + row[props.codeName]}>
                                        <Icon className="tableEdit" key="edit" icon={ic_mode_edit} size={22} />
                                      </Link>
                                    </div>
                                  </Tooltip>
                                  <Tooltip title="Excluir registro">
                                    <div style={{ margin: 0, display: 'inline' }}>
                                      <Icon className="tableDelete" key="delete" icon={ic_delete} size={22} onClick={(e) => handleDelete(e, row[props.codeName], props.regName)} />
                                    </div>
                                  </Tooltip>
                                </>
                              )}
                            </TableCell>
                          ) : (<></>)}
                          {columns.map((column) => {
                            const value = row[column.id];
                            if (column.image) {
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  <image src={value ? api.backendUrl + '/static/upload/lotes/' + row[props.codeName] + '/' + value : api.backendUrl + '/static/upload/lotes/no-image.jpg'} />
                                </TableCell>
                              )
                            } else if (column.icon) {
                              let iconComponent = icons.find((item) => item.fk_sne === value)
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {iconComponent.icon}
                                </TableCell>
                              )
                            } else {
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === 'number' ? column.format(value) : value}
                                </TableCell>
                              );
                            }
                          })}
                        </TableRow>
                        <TableRow>
                          <FrOfertaDetail isOpen={isItemOpened} detail={row[props.codeName]} />
                        </TableRow>
                      </>
                    );
                  } else {
                    return (
                      <TableRow aria-checked={isItemSelected} hover role="checkbox" tabIndex={-1} key={row[props.codeName]} selected={isItemSelected}>
                        <TableCell padding="checkbox" onClick={(event) => handleClick(event, row[props.codeName])}>

                        </TableCell>
                        {!props.readOnly ? (
                          <TableCell>

                            {props.propostas ? (
                              <>
                                <input
                                  type="file"
                                  name="arquivo"
                                  id={"html_btn_manual_" + row[props.codeName]}
                                  accept=".pdf"
                                  onChange={e => handleSelectedFile(e, row[props.codeName])}
                                  hidden
                                />

                                <Tooltip title="Imprimir Termo de Adesão">
                                  <div style={{ margin: 0, display: 'inline' }}>
                                    <Icon className="tableDelete" key="pdf" icon={ic_picture_as_pdf} size={18} onClick={(e) => handlePdf(e, row[props.codeName], props.regName)} />
                                  </div>
                                </Tooltip>

                                <Tooltip title="Upload de Arquivos">
                                  <div style={{ margin: 0, display: 'inline' }}>
                                    <Icon className="tableDelete" key="pdf" icon={upload} size={18} onClick={(e) => handleUpload(e, row[props.codeName], props.regName)} />
                                  </div>
                                </Tooltip>

                              </>
                            ) : (
                              <>
                                <Tooltip title="Editar registro">
                                  <div style={{ margin: 0, display: 'inline' }}>
                                    <Link to={"/sistema/" + props.regName + "/registro?codigo=" + row[props.codeName]}>
                                      <Icon className="tableEdit" icon={ic_mode_edit} size={22} />
                                    </Link>
                                  </div>
                                </Tooltip>
                                <Tooltip title="Excluir registro">
                                  <div style={{ margin: 0, display: 'inline' }}>
                                    <Icon className="tableDelete" key="delete" icon={ic_delete} size={22} onClick={(e) => handleDelete(e, row[props.codeName], props.regName)} />
                                  </div>
                                </Tooltip>
                              </>
                            )}
                          </TableCell>
                        ) : (<></>)}
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.image) {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <img src={value ? api.backendUrl + '/static/upload/lotes/' + row[props.codeName] + '/' + value : api.backendUrl + '/static/upload/lotes/no-image.jpg'} style={{ maxHeight: '60px' }} />
                              </TableCell>
                            )
                          } else if (column.icon) {
                            let iconComponent = icons.find((item) => item.fk_sne === value)
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {iconComponent.icon}
                              </TableCell>
                            )
                          } else {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                              </TableCell>
                            );
                          }
                        })}
                      </TableRow>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </ThemeProvider>
  );
}

export default FrTable